module.exports = "img/flags/FK.69a3418.png";